import React, { useState } from "react";
import { AuditTrialVM } from "../../Models/ViewModels";
import * as userManager from '../../Services/UserSessionManager';
import { AuditInfo } from "../EmployeeInformation/AuditInfo";
import { EditInfo } from "../EmployeeInformation/EditInfo";
import { EmployeeDetails } from "../EmployeeInformation/EmployeeDetails";
import { EmployeeInformation } from "../EmployeeInformation/EmployeeInfo";
import { KRAInfo } from "../EmployeeInformation/KRAInfo";

type attributes = {
    title: string,
    value: string,
    onClick():void
}

export const SingleStat = (props: any) => {
    const [checkRole,setCheckRole]=useState(userManager.GetUserRole());
    const [audit, setAudit] = useState(new Array<AuditTrialVM>());

    return (    
   
    <div className="text-center d-flex align-items-center flex-column justify-content-center">
        {props.title}
        <h1>{props.value}</h1>
        {props.onClick && <small className="text-primary link-simple" onClick={props.onClick}>Show Details...</small>}
    </div>)
}